import Hide from './Hide'
import Show from './Show'

export const HideWhen = Hide
export const ShowWhen = Show
